import { TableBody, TableCell, TableHead, Pagination, TableRow, Stack, Typography, Box, Button, Modal, Card, CardContent, IconButton, MenuItem } from '@mui/material';
import React, { useState, useEffect } from 'react';
import SearchTxtField from '../../../components/SearchTxtField';
import StyledTableContainer from '../../../components/StyledTableContainer';
import route from '../../../utils/Routes';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import CustomDropDown from '../../../components/CustomDropDown';
import { convert10, formatDateWithJs, formatUserType, getBalance, getSrchTypeTxt, isEmpty, isNotEmpty, NumFormatter } from '../../../utils/format';
import { ArrowDropDown, Settings } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import ScrollBox from '../../../components/ScrollBox';
import { List, ListItem, Checkbox } from "@mui/material";
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert } from '../../../components/notify';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { Edit } from '@mui/icons-material';
import ClientRemark from './ClientRemark';
import constants from '../../../utils/Constants';
import { getPoTrackingServ } from '../../../services/po-service';
import { poTrackingExcelServ } from '../../../services/excel-service';
import DDMenu from '../../../components/DDMenu';
import { FaSortAmountDown, FaSortAmountUpAlt } from "react-icons/fa";

const doColumns = [
    { id: 'doIdStrg', label: "DO ID", align: 'left', minWidth: 50 },
    { id: 'actDoNum', label: "DO NUMBER", align: 'left', minWidth: 50 },
    { id: 'doLineNo', label: "DOL", align: 'left', minWidth: 30 },
    { id: 'deliveredQty', label: "QTY", align: 'left', minWidth: 30 },
    { id: 'deliveredAt', label: "DELIVERED ON", align: 'left', minWidth: 30 },
    { id: 'invNo', label: "INVOICE NO", align: 'left', minWidth: 30 },
    { id: 'invDate', label: "INVOICE DATE", align: 'left', minWidth: 30 },
    { id: 'pymtStatus', label: "PAYMENT STATUS", align: 'left', minWidth: 30 },
]

const ddArr = [
    { value: "actPoNum", label: "PO Number" },
    { value: "poIdStrg", label: "Order Request ID" },
    { value: "comProdIdStrg", label: "Material Code" },
    { value: "prodName", label: "Description" },
    { value: "mfrName", label: "Original MNFR" },
    { value: "actDoNum", label: "DO Number" },
    { value: "doIdStrg", label: "DO ID" }
]

const statusArr = [
    { value: "all", label: "ALL" },
    { value: "awaiting_post_po_clarify", label: "AWAITING POST-PO CLARIFICATION" },
    { value: "packing_in_prog", label: "PACKING IN PROGRESS" },
    { value: "material_ready", label: "MATERIAL IS READY" },
    { value: "awaiting_sdo_dhl_pickup", label: "AWAITING SDO/DHL PICK-UP" },
    { value: "back_order", label: "BACK ORDER" },
    { value: "partially_del", label: "PARTIALLY DELIVERED" },
    { value: "del_completed", label: "DELIVERY COMPLETED" },
    { value: "na", label: "NA" },
];



export default function PoTrackingList({ type = "amtc" }) {
    const navigate = useNavigate();
    const location = useLocation();
    const { setLoadingScreen, ctxtUser, setNavComValue } = useAuthContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const queryComId = searchParams.get("comId");
    const searchType = searchParams.get("st") || ddArr[0].value;
    const querySearchWord = searchParams.get("s") || "";
    const selStatus = searchParams.get("status") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const tokenComId = ctxtUser?.comId;
    const comId = ctxtUser?.isComUser ? tokenComId : queryComId;
    const userType = ctxtUser?.userType;

    const columns = [
        { id: 'poIdStrg', label: "Order Req ID", align: 'left', minWidth: 150, },
        { id: 'actPoNum', label: "PO NUMBER", align: 'left', minWidth: 150, },
        { id: 'lineNo', label: "POL", align: 'left', minWidth: 150 },
        { id: 'comProdIdStrg', label: "MATERIAL CODE", align: 'left', minWidth: 150 },
        { id: 'mfrName', label: "ORIGINAL MNFR", align: 'left', minWidth: 150 },
        { id: 'prodName', label: "DESCRIPTION", align: 'left', minWidth: 150 },
        { id: 'prodStatus', label: "STATUS", align: 'left', minWidth: 120 },
        { id: 'orderedQty', label: "PO QTY", align: 'left', minWidth: 120 },
        { id: 'poDeliveredQty', label: "DELIVERED QTY", align: 'left', minWidth: 120 },
        { id: 'balQty', label: "REMAINING QTY", align: 'left', minWidth: 120 },
        { id: 'do', label: "No of DO", align: 'left', minWidth: 100 },
        { id: 'estTimeArr', label: "ETA", align: 'left', minWidth: 120 },
        { id: 'expecDelDate', label: "ETD", align: 'left', minWidth: 120 },
        { id: 'delLocation', label: "DELIVERY LOCATION", align: 'left', minWidth: 120 },
        { id: 'isPaid', label: "PAYMENT STATUS", align: 'left', minWidth: 120 },
        { id: 'amtcRemarks', label: "AMTC REMARKS", align: 'left', minWidth: 120 },
        { id: 'clientRemarks', label: "CLIENT REMARKS", align: 'left', minWidth: 120 },
        ...((ctxtUser?.userType === constants.focalPoint || ctxtUser?.userType === constants.lineManager) ? [{ id: 'editRemark', label: "EDIT REMARK", align: 'left', minWidth: 10 }] :
            (ctxtUser?.userType === constants.admin || ctxtUser?.userType === constants.ma || ctxtUser?.userType === constants.sourcing || ctxtUser?.userType === constants.store) ?
                [{ id: 'edit', label: "EDIT", align: 'left', minWidth: 10 }] :
                ctxtUser?.userType === constants.accounts ? [{ id: 'editInv', label: "EDIT INVOICE", align: 'center', minWidth: 10 }] : []),
    ];


    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const limit = 7;
    const theme = useTheme();
    const currProj = JSON.parse(localStorage.getItem('currProj') || "{}");
    const projIdStrg = currProj?.projIdStrg;
    const sort = searchParams.get("sort") || "DESC";
    const { isLoading, isError, error, data: potDataArr } = useQuery([QueryKey.poTracking, pgNo, isSrchBtnClick, comId, ctxtUser?.userType, projIdStrg, selStatus, ctxtUser?.userId, sort],
        () => getPoTrackingServ({
            comId, limit, pageNumber: pgNo, searchWord, searchType, userType: ctxtUser?.userType, projIdStrg,
            prodStatus: selStatus, userId: ctxtUser?.userId, sort
        }), {
        enabled: isNotEmpty(comId),
        keepPreviousData: true
    });

    const [colMdlOpen, setColMdlOpen] = useState(false);
    const [checkedItems, setCheckedItems] = useState([...columns]);
    const [visibleColumns, setVisibleColumns] = useState([...columns]);
    const [selectAll, setSelectAll] = useState(true);   // Track if all items are selected
    const [expandedRows, setExpandedRows] = useState([]);



    const [currPoProd, setCurrPoProd] = useState({});
    const [crmMdl, setCrmMdl] = useState(false);
    const handleCrmMdlClose = () => setCrmMdl(false);
    const handleCrmMdlOpen = (poProdData) => {
        // if (poProdData?.isTemp === 1)
        //     return;
        setCurrPoProd(poProdData);
        setCrmMdl(true);
    }


    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);


    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);



    useEffect(() => {
        if (!comId) {
            navigate("/", { replace: true });
        }
    }, [comId, navigate]);



    useEffect(() => {
        if (type === "amtc") {
            setNavComValue({ comId: comId });
            return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);


    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleStatusSelect = (status) => {
        //  setSelUserType(role); // Update the selected status
        setSearchParams(prev => {
            prev.set("status", status)
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
        handleMenuClose();
    };

    const handleColMdlOpen = () => setColMdlOpen(true);
    const handleColMdlClose = () => setColMdlOpen(false);


    const handleToggle = (column) => {
        const currentIndex = checkedItems.findIndex((item) => item.id === column.id);
        const newChecked = [...checkedItems];
        if (currentIndex === -1) {
            newChecked.push(column);// Add the column object if not already in the array
        } else {
            newChecked.splice(currentIndex, 1); // Remove the column object if it's already in the array
        }
        setCheckedItems(newChecked);
    };

    const handleSelectAll = () => {
        if (selectAll) {
            setCheckedItems([]);// Deselect all items
        } else {
            setCheckedItems(columns);  // Select all items
        }
        setSelectAll(!selectAll); // Toggle the state
    };

    const handleExpandRow = (rowId) => {
        setExpandedRows((prevExpandedRows) => {
            if (prevExpandedRows.includes(rowId)) {
                return prevExpandedRows.filter((id) => id !== rowId);
            } else {
                return [...prevExpandedRows, rowId];
            }
        });
    };

    async function onSearchBtnClick(e) {
        // setSearchKeyWord(searchWord);
        // setSearchKeyType(searchType);
        setIsSrchBtnClick((prevVal) => ++prevVal)
        // setPageNumber(1);
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
        setExpandedRows([]);
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    function handleDDChange(e) {
        setSearchParams(prev => {
            prev.set("st", e.target.value)
            return prev
        }, { replace: true })
    }

    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };

    function handleMdlSave() {
        setVisibleColumns(checkedItems);
        handleColMdlClose();
        setExpandedRows([]);
    }

    const handleEditClick = (poProdId, isTemp, poId) => {
        if (isTemp === 1) {
            navigate(route.aEditPot, { state: { comId, poId: poId, pgNo, st: searchType, s: querySearchWord } })
        } else {
            navigate(route.aEditPoProd, { state: { comId, poProdId } })
        }
    };

    const handleEditInvClick = (poProdId, isTemp, poId) => {
        if (isTemp === 1) {
            navigate(route.aEditPotInv, { state: { comId, poProdId: poProdId, pgNo, st: searchType, s: querySearchWord } })
        } else {
            // navigate(route.aEditPoProd, { state: { comId, poProdId } })
        }
    };

    function handlePoNumClick(poIdStrg, isTemp) {
        if (userType === constants.approver)
            return;
        if (isTemp === 1)
            return;
        if (type === "amtc")
            navigate(`${route.aPoInfo}/?poId=${poIdStrg}`);
        else
            navigate(`${route.cPoInfo}/?poId=${poIdStrg}`);
    }

    function handleDoNumClick(doIdStrg, isTemp) {
        if (userType === constants.approver)
            return;
        if (isTemp === 1)
            return;
        if (ctxtUser?.isComUser)
            navigate(`${route.cDoInfo}/?doId=${doIdStrg}`);
        else
            navigate(`${route.aDoInfo}/?doId=${doIdStrg}`);
    }


    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            return prev
        }, { replace: true })
    }

    async function downloadExcel() {
        setLoadingScreen(true);
        try {
            const userType = ctxtUser?.userType;
            let filterObj = {
                ...(comId && { comId }),
                ...(searchWord && { searchWord }),
                ...(searchType && { searchType }),
                ...(limit && { limit }),
                ...(pgNo && { offset: (pgNo * limit) - limit }),
            }

            if (userType === constants.lineManager || userType === constants.focalPoint) {
                filterObj = {
                    ...filterObj,
                    ...(projIdStrg && { projIdStrg })
                }
            }
            const url = await poTrackingExcelServ({ filterObj, columns: visibleColumns, doColumns });
            // Create and trigger download
            const a = document.createElement('a');
            a.href = url;
            const now = new Date();
            const fileName = `tracking_record_${now.toISOString().replace(/[-T:.Z]/g, '')}.xlsx`;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.log(err);
            customAlert(err)
        }
        setLoadingScreen(false);
    }

    function handleSortClick() {
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("sort", sort === 'DESC' ? "ASC" : "DESC")
            return prev
        }, { replace: true })
    }


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }


    return (
        <Stack height={"100%"} width={"100%"}>
            <Stack direction={"row"} sx={{ width: '100%', pr: 2, mb: 2, mt: 1, alignItems: 'center', justifyContent: 'space-between' }} >
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>PO Tracking List</Typography>

                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={1}>
                    <Box mb={0.5}><SearchTxtField variant={"outlined"} searchKeyWord={searchWord} onSearch={onSearch} handleOnClear={handleOnClear}
                        onBtnClick={onSearchBtnClick} placeholder={`Search By ${getSrchTypeTxt(ddArr, searchType)} .....`} /></Box>
                    <CustomDropDown height={30} width={140} handleDDChange={handleDDChange} ddArr={ddArr} defaultValue={searchType ?? ddArr[0].value} />
                </Stack>
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2}>
                    <Button onClick={downloadExcel}
                        sx={{ borderRadius: 1, backgroundColor: theme.palette.custom.btn, width: 100, fontSize: 14, color: "white", padding: 0.1, }}
                        variant="contained"  >Export</Button>

                    {/* <ImageButton>
                        <img src={settingsSvg} alt="Example Button" style={{ height: 35 }} onClick={handleColMdlOpen} />
                    </ImageButton> */}
                    <IconButton onClick={handleColMdlOpen}>
                        <Settings sx={{ color: theme.palette.custom.btn }} />
                    </IconButton>
                    <IconButton onClick={handleSortClick} >
                        {sort === 'DESC' ? <FaSortAmountDown size={18} color={theme.palette.custom.btn} /> : <FaSortAmountUpAlt size={18} color={theme.palette.custom.btn} />}
                    </IconButton>
                </Stack>
            </Stack>
            {/* <Stack sx={{width:{ lg:"100%" ,md:"80%"}}}> */}

            {visibleColumns && <StyledTableContainer height={"100%"} isStickyHeader={true}>
                <TableHead>
                    <TableRow >
                        {visibleColumns.map((column) => (
                            <TableCell align={column.align} style={{ minWidth: column.minWidth }} key={column.id} sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                {column.label}
                                {column.id === 'prodStatus' && (
                                    <div style={{ marginTop: -33, marginLeft: 50, height: 35 }} >
                                        <IconButton aria-haspopup="true" onClick={handleMenuOpen}>
                                            <ArrowDropDown />
                                        </IconButton>
                                    </div>
                                )}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(potDataArr?.arr || []).map((row) => {
                        return (
                            <React.Fragment key={row.id}>
                                <TableRow hover tabIndex={-1}
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 }, height: 50,
                                        backgroundColor: expandedRows.includes(row.id) ? "rgba(162, 214, 249, 0.4)" : 'transparent',
                                    }} >

                                    {visibleColumns.map((column) => {
                                        const value = row[column.id];
                                        switch (column.id) {
                                            case "poIdStrg":
                                            case "actPoNum":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {isEmpty(value) ? "NA" : <Button variant="text" sx={{ color: row?.isTemp === 1 ? "blue" : "black", ml: -1, fontSize: 12 }}
                                                        onClick={() => handlePoNumClick(row?.poIdStrg, row?.isTemp)}>
                                                        {value}
                                                    </Button>}
                                                </TableCell>
                                            case "edit":
                                                return <TableCell align="center" key={column.id}>
                                                    <IconButton onClick={() => handleEditClick(row["id"], row?.isTemp, row?.poId)} color="primary">
                                                        <Edit sx={{ color: theme.palette.custom.btn }} />
                                                    </IconButton>
                                                </TableCell>
                                            case "editRemark":
                                                return <TableCell align="center" key={column.id}>
                                                    <IconButton onClick={() => handleCrmMdlOpen(row)} color="primary">
                                                        <Edit sx={{ color: theme.palette.custom.btn }} />
                                                    </IconButton>
                                                </TableCell>
                                            case "editInv":
                                                return <TableCell align="center" key={column.id}>
                                                    <IconButton onClick={() => handleEditInvClick(row["id"], row?.isTemp, row?.poId)}
                                                        sx={{ color: "primary" }} disabled={row?.isTemp === 0}>
                                                        <Edit sx={{ color: row?.isTemp === 0 ? "rgba(162, 214, 249, 0.4)" : theme.palette.custom.btn }} />
                                                    </IconButton>
                                                </TableCell>
                                            case "prodStatus":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {(value === null || value === "" || value === "null") ? "NA" : formatUserType(value)}
                                                </TableCell>
                                            case "orderedQty":
                                            case "poDeliveredQty":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {NumFormatter(value)}
                                                </TableCell>
                                            case "balQty":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {getBalance(row?.orderedQty, row?.poDeliveredQty)}
                                                </TableCell>
                                            case "estTimeArr":
                                            case "expecDelDate":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {formatDateWithJs(value)}
                                                </TableCell>
                                            case "isPaid":
                                                return <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                    {(value === null || value === "" || value === "null") ? "NA" : convert10(value)}
                                                </TableCell>
                                            case "do":
                                                return (
                                                    <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        <Stack direction="row" alignItems="center" gap={1}
                                                            onClick={() => handleExpandRow(row.id)} sx={{ cursor: 'pointer' }}>
                                                            {expandedRows.includes(row.id) ? <ExpandLess color='error' /> : <ExpandMore sx={{ color: theme.palette.custom.btn }} />}
                                                            <span>{row?.doArr?.length ?? 0}</span>
                                                        </Stack>
                                                    </TableCell>
                                                )
                                            default:
                                                return (
                                                    <TableCell key={column.id} align={column.align} sx={{ textAlign: column.align, fontSize: 13 }}>
                                                        {(value === null || value === "" || value === "null") ? "NA" : value}
                                                    </TableCell>
                                                );
                                        }
                                    })}
                                </TableRow>
                                {
                                    expandedRows.includes(row.id) && (
                                        <TableRow>
                                            <TableCell colSpan={visibleColumns.length} sx={{ padding: 0 }}>
                                                <Box sx={{
                                                    pb: 2, pl: 5, pt: 1,
                                                    maxHeight: expandedRows.includes(row.id) ? 300 : '0', // Max height for smooth transition
                                                    opacity: expandedRows.includes(row.id) ? 1 : 0, // Fade-in/out effect
                                                    transform: expandedRows.includes(row.id) ? 'scaleY(1)' : 'scaleY(0.9)', // Scale effect
                                                    overflow: 'hidden',
                                                    transition: 'max-height 1s cubic-bezier(0.25, 0.8, 0.25, 1), opacity 0.5s ease-in-out, transform 0.5s ease-in-out', // Apply smooth transition
                                                    backgroundColor: expandedRows.includes(row.id) ? '#f0f4f8' : 'transparent', // Background color for expanded row
                                                }}>
                                                    <Stack>
                                                        <Typography variant="h6" mb={1}>List of DOs:</Typography>
                                                        <Stack direction={"row"} pl={10}>
                                                            <StyledTableContainer width={"50%"} height={180} isStickyHeader={true}>
                                                                <TableHead sx={{ backgroundColor: "rgba(253, 240, 213, 0.4)" }}>
                                                                    <TableRow>
                                                                        {doColumns.map((doColumn, index) => (
                                                                            <TableCell align={doColumn.align} style={{ minWidth: doColumn.minWidth }} key={`doColumn-${doColumn.id}-${index}`}
                                                                                sx={{ backgroundColor: "rgba(253, 240, 213, 1)" }}>
                                                                                {doColumn.label}
                                                                            </TableCell>
                                                                        ))}
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {(row?.doArr ?? []).map((doItem) => (
                                                                        <TableRow key={`doItem-${doItem.id}-`} sx={{
                                                                            height: 37, '&:last-child td, &:last-child th': { border: 0 },
                                                                        }}>
                                                                            {doColumns.map((doColumn) => {
                                                                                const doVal = doItem[doColumn.id];
                                                                                switch (doColumn.id) {
                                                                                    case "doIdStrg":
                                                                                    case "actDoNum":
                                                                                        return <TableCell key={doColumn.id} align={doColumn.align} sx={{ textAlign: doColumn.align, fontSize: 13 }}>
                                                                                            {isEmpty(doVal) ? "NA" : <Button variant="text" sx={{ color: "black", ml: -1, fontSize: 12 }}
                                                                                                onClick={() => handleDoNumClick(doVal, row?.isTemp)}>
                                                                                                {doVal}
                                                                                            </Button>}
                                                                                        </TableCell>
                                                                                    case "doLineNo":
                                                                                    case "deliveredQty":
                                                                                        return <TableCell key={doColumn.id} align={doColumn.align} sx={{ textAlign: doColumn.align, fontSize: 13 }}>
                                                                                            {NumFormatter(doVal)}
                                                                                        </TableCell>
                                                                                    case "deliveredAt":
                                                                                    case "invDate":
                                                                                        return <TableCell key={doColumn.id} align={doColumn.align} sx={{ textAlign: doColumn.align, fontSize: 13 }}>
                                                                                            {formatDateWithJs(doVal)}
                                                                                        </TableCell>
                                                                                    case "pymtStatus":
                                                                                        return <TableCell key={doColumn.id} align={doColumn.align} sx={{ textAlign: doColumn.align, fontSize: 13 }}>
                                                                                            {formatUserType(doVal)}
                                                                                        </TableCell>
                                                                                    default:
                                                                                        return (
                                                                                            <TableCell key={doColumn.id} align={doColumn.align} sx={{ textAlign: doColumn.align, fontSize: 13 }}>
                                                                                                {(doVal === null || doVal === "" || doVal === "null") ? "NA" : doVal}
                                                                                            </TableCell>
                                                                                        );
                                                                                }
                                                                            })}
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </StyledTableContainer>
                                                        </Stack>
                                                    </Stack>

                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        );
                    })}
                </TableBody>

            </StyledTableContainer>}
            {/* </Stack> */}
            <Stack sx={{ alignItems: "center", mt: 1 }}>
                <Pagination count={Math.ceil(potDataArr?.totalCount / limit) || 0} color={"primary"} page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
            </Stack>

            <Modal open={colMdlOpen} onClose={handleColMdlClose}>
                <Box sx={modalStyle} >
                    <Stack width={"100%"} justifyContent={"center"} alignItems={"center"}>
                        <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Select Columns</Typography>
                    </Stack>
                    <ScrollBox height={"90%"}>
                        <List >
                            {columns.map((column) => (
                                <ListItem key={column.id} disablePadding style={{ marginBottom: "8px", }} >
                                    <Card
                                        onClick={() => handleToggle(column)} // Toggle on card click
                                        style={{
                                            width: "100%", display: "flex", alignItems: "center", padding: "8px",
                                            backgroundColor: checkedItems.some((item) => item.id === column.id)
                                                ? "#e3f2fd" : "#f5f5f5",
                                            cursor: "pointer",
                                        }}>
                                        <Checkbox
                                            checked={checkedItems.some((item) => item.id === column.id)}
                                            onChange={() => handleToggle(column)}
                                            onClick={(e) => e.stopPropagation()} // Prevent card click from toggling twice
                                        />
                                        <CardContent style={{ padding: 0, paddingLeft: "8px" }}>
                                            <Typography variant="body1">{column.label}</Typography>
                                        </CardContent>
                                    </Card>
                                </ListItem>
                            ))}
                        </List>
                    </ScrollBox>
                    <Stack direction={"row"} width={"100%"} justifyContent={"center"} alignItems={"center"} gap={2}>
                        <Button variant='contained' onClick={handleSelectAll}
                            sx={{ color: "white", backgroundColor: theme.palette.custom.sub, height: 30, width: 150 }}>
                            {selectAll ? "Deselect All" : "Select All"}
                        </Button>
                        <Button variant='contained' onClick={handleMdlSave}
                            sx={{ color: "white", backgroundColor: theme.palette.custom.btn, height: 30, width: 150 }}>
                            Save</Button>
                    </Stack>
                </Box>
            </Modal>
            {potDataArr && <ClientRemark modalOpen={crmMdl} handleModalClose={handleCrmMdlClose} poProdData={currPoProd} />}
            <DDMenu open={open} handleClose={handleMenuClose} anchorEl={anchorEl} >
                {statusArr.map((i) => <MenuItem onClick={() => handleStatusSelect(i.value)} key={i.label}>
                    {i.label}
                </MenuItem>)}
            </DDMenu>
        </Stack>
    );
}


const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 470, height: "90%",
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    px: 4,
    py: 3,
    borderRadius: 2
};

